import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import {
  FEATURED_CAROUSEL_LIMIT,
  willOverflowFeaturedCarousel,
} from './pinnedContent';

const LABELS = {
  notices: { plural: 'obvestil', singular: 'obvestilo' },
  benefits: { plural: 'ugodnosti', singular: 'ugodnost' },
  polls: { plural: 'anket', singular: 'anketa' },
};

export function useFeaturedCarouselPinWarning({
  tenantId,
  isPinned,
  excludeId,
  countActivePinned,
}) {
  const [activeCount, setActiveCount] = useState(null);

  useEffect(() => {
    if (!tenantId || !isPinned || typeof countActivePinned !== 'function') {
      setActiveCount(null);
      return undefined;
    }

    let cancelled = false;
    countActivePinned(tenantId, excludeId)
      .then((count) => {
        if (!cancelled) setActiveCount(count);
      })
      .catch(() => {
        if (!cancelled) setActiveCount(null);
      });

    return () => {
      cancelled = true;
    };
  }, [tenantId, isPinned, excludeId, countActivePinned]);

  const showOverflowWarning = willOverflowFeaturedCarousel(activeCount ?? 0, isPinned);

  return { showOverflowWarning, activeCount };
}

export default function FeaturedCarouselPinWarning({
  visible,
  module = 'notices',
}) {
  if (!visible) return null;

  const labels = LABELS[module] ?? LABELS.notices;

  return (
    <Alert variant="warning" className="featured-carousel-pin-warning mb-3">
      V mobilni aplikaciji je v drsni vrstici prikazanih največ{' '}
      <strong>{FEATURED_CAROUSEL_LIMIT}</strong> pripetih {labels.plural}. Ko pripnete
      še eno, ostane pripeto, vendar se najšibkejše pripeto {labels.singular} prestavi
      v običajni seznam spodaj.
    </Alert>
  );
}
